import { AbstractViewState, ViewState } from '../deposit/DepositState'

class WithdrawState extends AbstractViewState {
  constructor(public key: string, public substate?: any) {
    super()
    if (substate) {
      this.subState = substate
    } else {
      this.subState = {}
    }
  }

  isAfter(target: this): boolean {
    const states = Object.values(WithdrawStates)

    const c = states.findIndex(s => s.key === this.key)
    const t = states.findIndex(s => s.key === target.key)
    return c >= t
  }
  isBefore(target: this): boolean {
    const states = Object.values(WithdrawStates)

    const c = states.findIndex(s => s.key === this.key)
    const t = states.findIndex(s => s.key === target.key)
    return c <= t
  }
  isIn(targets: this[]): boolean {
    return targets.some(t => t === this)
  }

  next(context?: any): ViewState {
    switch (this.key) {
      case WithdrawStates.CONNECT.key:
        return WithdrawStates.CHOOSE_AMOUNT
      case WithdrawStates.CHOOSE_AMOUNT.key:
        return WithdrawStates.VALID
      case WithdrawStates.VALID.key:
        return WithdrawStates.PREVIEW
      case WithdrawStates.PREVIEW.key:
        return WithdrawStates.PROCESSING
      case WithdrawStates.PROCESSING.key:
        return WithdrawStates.TRANSACTION_SUCCESS
    }
    return WithdrawStates.CHOOSE_AMOUNT
  }
}

// Written here for auto-completion
export const WithdrawStates = {
  CONNECT: new WithdrawState('CONNECT'),
  CHOOSE_AMOUNT: new WithdrawState('CHOOSE_AMOUNT'),
  VALID: new WithdrawState('VALID'),
  PREVIEW: new WithdrawState('PREVIEW'),
  PROCESSING: new WithdrawState('PROCESSING'),
  TRANSACTION_SUCCESS: new WithdrawState('TRANSACTION_SUCCESS'),
  TRANSACTION_FAILED: new WithdrawState('TRANSACTION_FAILED'),
}
